// extracted by mini-css-extract-plugin
module.exports = {"Emojis__item":"bez_a bgu_vc bgu_rm bgu_wf"};